/*
 * Copyright (c) 2022 OTB Africa. All rights reserved. <https://otbafrica.com>
 *
 * Created Date: Monday, September 26th 2022, 3:13:46 pm
 * Author: OTB Africa, developers@otbafrica.com
 *
 * Use of this source code is governed by the license that can be found in
 * the LICENSE file or at https://developers.otbafrica.com/licenses/
 */

import Paper from "@mui/material/Paper";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import { useFormBuilderStore, currentFormSelector } from "form-builder/stores";
import { NumberingSequenceForm } from "common/components/numbering-sequence";
import { COLORSCHEME } from "theme/styles";
import { IconText, Image } from "ui-widgets";

export const SubmissionIdentifierSequence = () => {
  const currentFormConfiguration = useFormBuilderStore(currentFormSelector);

  return (
    <Paper sx={{ padding: 4 }}>
      <Stack spacing={4}>
        <IconText
          textComponent={
            <Typography variant="h5" color={COLORSCHEME.primary}>
              Form Submission Identifier
            </Typography>
          }
          icon={<Image src="/img/document.png" width={40} height={40} />}
        />
        <NumberingSequenceForm numberingSequenceId={currentFormConfiguration?.sequence} />
      </Stack>
    </Paper>
  );
};
